/* eslint-disable consistent-return */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './Share.scss'

const Share = ({
  qrCodeDisplayed,
  clientSdkId,
  scenarioId,
  locale,
  referringWebsite
}) => {
  const YOTI_SHARE_CONFIG = {
    locale,
    currentUrl: referringWebsite,
    elements: [
      {
        domId: 'inline-qr-container',
        type: 'inline',
        clientSdkId,
        scenarioId
      }
    ]
  }

  useEffect(() => {
    Yoti.Share.init(YOTI_SHARE_CONFIG)
  }, [])

  const shareClassName = classNames('share', {
    'share__with-qr-code': qrCodeDisplayed,
    'share__with-app-link': !qrCodeDisplayed
  })

  const inlineQrClassName = classNames('inline-qr', {
    'inline-qr__with-qr-code': qrCodeDisplayed,
    'inline-qr__with-app-link': !qrCodeDisplayed
  })

  return (
    <div className={shareClassName}>
      <div id="inline-qr-container" className={inlineQrClassName} />
    </div>
  )
}

Share.propTypes = {
  qrCodeDisplayed: PropTypes.bool.isRequired,
  clientSdkId: PropTypes.string.isRequired,
  scenarioId: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  referringWebsite: PropTypes.string.isRequired
}

export default Share
